module.exports = __webpack_public_path__ + "img/logo.c2f963d4.png";